import { Button, CircularProgress } from '@mui/joy';
import React, { Dispatch, SetStateAction } from 'react'
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import { ColDef } from "ag-grid-community";

type ViewComponent2Props = {
    headerName: string;
    setMetricsToggle: Dispatch<SetStateAction<boolean>>;
    section2ColDefs: ColDef<any>[];
    section2Data: any[];
    loading: boolean;
    section2width: Number;
    page_name: string;
}
const ViewComponent2: React.FC<ViewComponent2Props> = ({headerName, setMetricsToggle,
  section2ColDefs, section2Data, loading, section2width, page_name}) => {
  return (
    <div className="w-full p-2" style={{
        boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
        borderEndStartRadius: "8px",
        borderEndEndRadius: "8px",
        borderTopRightRadius: "8px",
        zIndex: 20
    }}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-start gap-4 self-stretch">
          <div className="flex flex-col justify-center items-start gap-1">
            <div
              className="self-stretch"
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
                textTransform: "uppercase"
              }}
            >
             {headerName}
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              color="neutral"
              sx={{
                height: 32,
                width: 80,
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#FFF",
                lineHeight: "20px",
                color: "#1C1C1E",
                ":hover": {
                  backgroundColor: "#FFF",
                },
                paddingX: "6px",
                paddingY: 0,
                gap: "8px",
                borderRadius: "6px",
                border: `1px solid #EAEAED`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                setMetricsToggle(true);
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  textAlign: "center",
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                {page_name === "comparison" ? "Metrics" : "Metrics & Parameters"}
              </div>
            </Button>

            {/* <Button
              color="neutral"
              sx={{
                height: 32,
                width: 80,
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#FFF",
                lineHeight: "20px",
                color: "#1C1C1E",
                ":hover": {
                  backgroundColor: "#FFF",
                },
                paddingX: "6px",
                paddingY: 0,
                gap: "8px",
                borderRadius: "6px",
                border: `1px solid #EAEAED`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M4.42308 9.01434C4.00211 9.01434 3.64579 8.8685 3.35413 8.57684C3.06246 8.28517 2.91663 7.92885 2.91663 7.50788V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V7.50788C17.0833 7.92885 16.9375 8.28517 16.6458 8.57684C16.3541 8.8685 15.9978 9.01434 15.5768 9.01434H4.42308ZM4.42308 7.76434H15.5768C15.6517 7.76434 15.7132 7.74031 15.7612 7.69225C15.8093 7.6442 15.8333 7.58274 15.8333 7.50788V4.42308C15.8333 4.34822 15.8093 4.28677 15.7612 4.23871C15.7132 4.19065 15.6517 4.16663 15.5768 4.16663H4.42308C4.34822 4.16663 4.28677 4.19065 4.23871 4.23871C4.19065 4.28677 4.16663 4.34822 4.16663 4.42308V7.50788C4.16663 7.58274 4.19065 7.6442 4.23871 7.69225C4.28677 7.74031 4.34822 7.76434 4.42308 7.76434ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V12.5C2.91663 12.079 3.06246 11.7227 3.35413 11.431C3.64579 11.1393 4.00211 10.9935 4.42308 10.9935H15.5768C15.9978 10.9935 16.3541 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5768V12.5C15.8333 12.4251 15.8093 12.3636 15.7612 12.3156C15.7132 12.2675 15.6517 12.2435 15.5768 12.2435H4.42308C4.34822 12.2435 4.28677 12.2675 4.23871 12.3156C4.19065 12.3636 4.16663 12.4251 4.16663 12.5V15.5768C4.16663 15.6517 4.19065 15.7132 4.23871 15.7612C4.28677 15.8093 4.34822 15.8333 4.42308 15.8333Z"
                  fill="#1C1C1E"
                />
              </svg>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  textAlign: "center",
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Parameters
              </div>
            </Button> */}
          </div>
        </div>

        {!loading ? (
        <div className={"ag-theme-quartz"}
          style={{
            maxWidth: "calc(100vw - 72px - 40px - 16px)",
            width: section2width.valueOf() > 8 || section2width === 0 ? "100%" : `${(Number(section2width)+ 1)  *150 + 3}px`,
            height: "205px",
            overflowY: "hidden",
            borderRadius: "0px",
          }}>
          <AgGridReact
            rowData={section2Data}
            columnDefs={section2ColDefs}
            rowHeight={32}
            headerHeight={36}
            context={{suffixArray: section2Data}}
            defaultColDef={{
              width: 150,  // ⬅️ sets all columns to 100px
              resizable: true, // optional: allow manual resizing
              cellStyle: { padding: 0, margin: 0 },
              headerClass: 'ag-header-no-padding'
          }}
          />
      </div>) : (
            <div className='h-[200px] w-full flex justify-center items-center'>
                <CircularProgress />
            </div>
        )}
      </div>
    </div>
  )
}

export default ViewComponent2